import httpservice from "./httpservice";

class CustomPlanService {
  // Fetch all plans
  getPlans(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.limit) params.limit = query.limit;
    if (query?.keyword) params.keyword = query.keyword;

    return httpservice.get("/admin/cp/meta/plans", { params });
  }

  // Create a custom plan
  createCustomPlan(data = {}) {
    return httpservice.post("/admin/cp/meta/plans", data);
  }

  // Update a custom plan
  editCustomPlan(data = {}) {
    return httpservice.put("/admin/cp/meta/plans", data);
  }

  // Get one plan by id
  getOne(query = {}) {
    const params = {};
    if (query?.id) params.id = query.id;

    return httpservice.get("/admin/cp/meta/custom-plans/single", { params });
  }

  // Update an existing custom plan (future-proof since you added id) 
  updateCustomPlan(data = {}) {
    return httpservice.put("/admin/cp/meta/custom-plans", data);
  }

  // Update status (Active / Inactive)
  updateStatus(id, status) {
    return httpservice.put("/admin/cp/meta/plans", {
      id,
      status,
    });
  }
  


}

export default new CustomPlanService();
